import {Box, Typography} from '@viptech/react-components'
import ReactPlayer from 'react-player'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'

const MoniGuide = () => {
  const {styledTheme} = usePersonalizedThemeByCompany()

  return (
    <Box display='flex' direction='column' backgroundColor='white' borderRadius='8px' padding='30px' overflow='auto' rowGap='30px'>
      <Box>
        <Typography variant='p' size='16px' weight={700} color={styledTheme.colors.primary}>
          Tutorial de integração Moni com o Brain!
        </Typography>
        <Typography variant='span' size='14px' color={'#5e6168'}>
          Abaixo você encontra um passo-a-passo com informações adicionais para configurar seu vms e um vídeo explicando de forma detalhada como completar a
          integração.
        </Typography>
      </Box>

      <Box display='flex' direction='column' rowGap='10px'>
        <Typography variant='p' size='14px'>
          Ao abrir a plataforma do Moni, vá em "Utilitários" {'->'} "Configurar" {'->'} "Softwares Integração"
        </Typography>

        <Typography variant='p' size='14px'>
          Assim que a nova janela abrir, inclua um novo item
        </Typography>

        <Typography variant='p' size='14px'>
          Insira a descrição desejada e preencha os campos "Usuário" e "Senha" com as credenciais de acesso pragmático geradas na plataforma do Brain
        </Typography>

        <Typography variant='p' size='14px'>
          Após a inclusão do novo item, vá em "Utilitários" {'->'} "Configurar" {'->'} "Softwares de Integração"
        </Typography>

        <Typography variant='p' size='14px'>
          Clique no item criado, vá em "Serviço" {'->'} "Moni Integração" e clique em "Ativar"
        </Typography>

        <Typography variant='p' size='14px'>
          Ative a caixa para Fixar IP e preencha a porta com o valor que desejar
        </Typography>

        <Typography variant='p' size='14px'>
          Vá no item desejado, e clique no ícone para adicionar algum código neste item
        </Typography>

        <Typography variant='p' size='14px'>
          Adicione o código para o tipo de detecção desejado, informe "E" na identificação e coloque a descrição de acordo com o código inserido.
        </Typography>

        <Typography variant='p' size='14px'>
          Por fim, escolha a cor desejada para fazer a detecção.
        </Typography>

        <Typography variant='p' size='14px'>
          <b>Códigos de detecção:</b>
          <Typography variant='p' size='14px'>
            B001 - PESSOA DETECTADA
            <br />
            B002 - VEÍCULO DETECTADO
            <br />
            B003 - ALIMENTO DETECTADO
            <br />
            B004 - UTENSÍLIOS DOMÉSTICOS DETECTADO
            <br />
            B005 - ELETRÔNICOS DETECTADOS
            <br />
            B006 - ANIMAL DETECTADO
            <br />
            B007 - OBJETOS PÚBLICO DETECTADO
            <br />
            B008 - OBJETOS PESSOAIS DETECTADO
            <br />
            B009 - OBJETOS ESPORTIVOS DETECTADO
            <br />
            B010 - VARIAÇÃO
            <br />
            B011 - ARMAS
            <br />
            B012 - AGLOMERAÇÃO
            <br />
            B013 - EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL DETECTADO
            <br /> B014 - AUSÊNCIA DE EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL DETECTADO
          </Typography>
        </Typography>
      </Box>

      <Box margin='10px'>
        <Typography variant='p' size='14px'>
          O vídeo a seguir explica de forma detalhada os passos para completar a integração:
        </Typography>
        <ReactPlayer url='https://youtu.be/XFC-d7GTCP8' controls={true} />
      </Box>
    </Box>
  )
}

export default MoniGuide
